<template>
  <InsurerPage :insurerSlug="$route.params.token">
    <template v-slot="{ insurer }">
      <v-app>
        <v-main>
          <v-container style="max-width: 500px">
            <div class="text-center" style="width: 100%">
              <InsurerLogo :insurer="insurer" />
            </div>

            <div class="mt-4">
              <v-row>
                <v-col>
                  <v-card outlined>
                    <v-card-title
                      >Atualização de dados de contacto</v-card-title
                    >
                    <v-card-text>
                      Por favor, confirme que os seus dados de contacto estão
                      corretos.

                      <v-row class="mt-2">
                        <v-col>
                          <v-list-item class="px-0 mx-0">
                            <v-list-item-content>
                              <v-list-item-subtitle>
                                Nome
                              </v-list-item-subtitle>
                              <v-list-item-title>
                                {{ name }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                      </v-row>
                      <div class="text-subtitle-1 mt-6 mb-3">Contactos</div>
                      <v-row>
                        <v-col>
                          <v-text-field
                            v-model="email"
                            label="Email*"
                            outlined
                            dense
                            hide-details
                            :color="insurer.color"
                            placeholder="Ex.: joao@gmail.com"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            v-model="contact1"
                            label="Contacto principal*"
                            outlined
                            dense
                            hide-details
                            :color="insurer.color"
                            placeholder="999 999 999"
                            v-mask="'### ### ###'"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="contact2"
                            label="Contacto secundário (opcional)"
                            outlined
                            dense
                            hide-details
                            :color="insurer.color"
                            placeholder="999 999 999"
                            v-mask="'### ### ###'"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <!-- <div class="text-subtitle-1 mt-6 mb-3">Morada</div>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="address.postalCode"
                        label="Código postal"
                        :color="insurer.color"
                        hide-details="auto"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="address.countryArea"
                        label="Distrito"
                        :color="insurer.color"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="address.city"
                        label="Concelho"
                        :color="insurer.color"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="9">
                      <v-text-field
                        v-model="address.street"
                        label="Morada"
                        :color="insurer.color"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="address.number"
                        label="Número"
                        :color="insurer.color"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                  </v-row> -->
                    </v-card-text>

                    <v-card-actions class="mt-2">
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="handleClickSave()"
                        :disabled="!validated"
                        :color="insurer.color"
                        :dark="validated"
                      >
                        Gravar e Continuar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-main>
      </v-app>
    </template>
  </InsurerPage>
</template>

<script>
import InsurerPage from "@/components/insurers/InsurerPage";
import InsurerLogo from "@/components/insurers/InsurerLogo.vue";

export default {
  mixins: [],

  components: { InsurerPage, InsurerLogo },

  props: {},

  data() {
    return {
      name: "",
      email: "",
      contact1: "",
      contact2: "",
      address: {
        postalCode: "4805081",
        countryArea: "Braga",
        city: "Guimarães",
        cityArea: "Caldelas",
        street: "Rua 19 de Junho, Caldas das Taipas",
        number: "100",
      },
      nif: "",
      contracts: [],
    };
  },

  methods: {
    handleClickSave() {
      if (!this.validated) {
        return;
      }

      this.saveInsured();

      this.$router.push({ name: "customers-terms-and-conditions" });
    },

    loadInsured() {
      const payload = localStorage.getItem("insured");

      const insured = JSON.parse(payload);

      this.email = insured.email;
      this.name = insured.name;
      this.contact1 = insured.contact1;
      this.contact2 = insured.contact2;
      this.nif = insured.nif;
      this.contracts = insured.contracts;
    },

    saveInsured() {
      const payload = JSON.stringify({
        email: this.email,
        contact1: this.contact1,
        contact2: this.contact2,
        iban: this.iban,
        name: this.name,
        address: this.address,
        nif: this.nif,
        contracts: this.contracts,
      });

      localStorage.setItem("insured", payload);
    },
  },

  computed: {
    validated() {
      if (this.contact1.length < 9) {
        return false;
      }

      if (this.contact2.length > 0 && this.contact2.length < 9) {
        return false;
      }

      return true;
    },
  },

  created() {
    this.loadInsured();
  },
};
</script>
